/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import NumberFormat from 'react-number-format';
// import Email from "react-email-autocomplete";

class JoinStepOne extends Component {
  state = {
    mouse: 0,
  };
  _dupUserid = () => {
    const { dupUserid } = this.props.childProps;
    dupUserid();
  };
  _dupNicname = () => {
    const { dupNicname } = this.props.childProps;
    dupNicname();
  };
  _onChange = (e) => {
    const { onChange } = this.props.childProps;
    ////console.log(e.target.name)
    onChange(e);
  };
  _onMobile = () => {
    const { onMobile } = this.props.childProps;
    onMobile();
  };
  _onIpin = () => {
    const { onIpin } = this.props.childProps;
    onIpin();
  };
  _goStep2 = () => {
    const { goStep2 } = this.props.childProps;
    goStep2();
  };
  _onMouseOver = (index) => {
    this.setState({
      mouse: index,
    });
  };
  _onNaver = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/naver/auth', '', '');
  };
  _onKakao = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/kakao/auth', '', '');
  };
  _onFacebook = () => {
    alert(0);
    const { apiUrl } = this.props;
    window.open(apiUrl + '/facebook/auth', '', '');
  };
  _onGoogle = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/google/auth', '', '');
  };
  _onTwitter = () => {
    const { apiUrl } = this.props;
    window.open(apiUrl + '/twitter/auth', '', '');
  };
  _chkValue = (e) => {
    const { chkValue } = this.props.childProps;
    chkValue(e);
  };
  _goRole = () => {
    const { history } = this.props;
    history.push('/customer/4');
  };
  render() {
    const { mouse } = this.state;
    const {
      userid,
      nicName,
      password,
      password_re,
      mobile,
      email,
      aAgree,
      mAgree,
      sAgree,
      isDupUsreid,
      isDupNicname,
      dupButtonState,
      dupButtonNicnameSate,
      age14,
    } = this.props.childProps;
    // const customDomains = [
    //   "naver.com",
    //   "nate.com",
    //   "gmail.com",
    //   "yahoo.com",
    //   "kakao.com",
    // ];
    return (
      <Fragment>
        <div className="login_content width5">
          <div className="login_padding">
            <h1>
              회원가입
              <span>
                회원가입에 필요한 필수 입력사항을 입력 후 약관에 동의해주세요!
              </span>
            </h1>

            <ul className="radius2">
              <li className={mouse === 0 ? 'on' : null}>
                <input
                  name="userid"
                  maxLength={30}
                  type="text"
                  className="common_input login_input"
                  readOnly={isDupUsreid ? true : false}
                  value={userid}
                  placeholder="아이디"
                  onChange={this._onChange}
                  onFocus={() => this._onMouseOver(0)}
                />
                <input
                  type="button"
                  value={
                    dupButtonState === 'C'
                      ? '재등록'
                      : dupButtonState === 'B'
                      ? '다시시도'
                      : dupButtonState === 'Z'
                      ? '확인중'
                      : dupButtonState === 'A'
                      ? '중복확인'
                      : '중복확인'
                  }
                  className="common_input input_btn"
                  onClick={this._dupUserid}
                />
              </li>
              <li
                className={mouse === 1 ? 'on' : null}
                onMouseEnter={this._onMouseOver}
              >
                <input
                  name="nicName"
                  maxLength={15}
                  type="text"
                  className="common_input login_input"
                  readOnly={isDupNicname ? true : false}
                  value={nicName}
                  placeholder="닉네임"
                  onChange={this._onChange}
                  onFocus={() => this._onMouseOver(1)}
                />
                <input
                  type="button"
                  value={
                    dupButtonNicnameSate === 'C'
                      ? '재등록'
                      : dupButtonNicnameSate === 'B'
                      ? '다시시도'
                      : dupButtonNicnameSate === 'Z'
                      ? '확인중'
                      : dupButtonNicnameSate === 'A'
                      ? '중복확인'
                      : '중복확인'
                  }
                  className="common_input input_btn"
                  onClick={this._dupNicname}
                />
              </li>
              <li>
                <input
                  maxLength={20}
                  name="password"
                  type="password"
                  className="common_input login_input"
                  value={password}
                  placeholder="비밀번호"
                  style={{
                    float: 'left',
                    boxSizing: 'border-box',
                    borderRight: '1px solid #333333',
                    width: '50%',
                  }}
                  onChange={this._onChange}
                />
                <input
                  maxLength={20}
                  name="password_re"
                  type="password"
                  className="common_input login_input"
                  value={password_re}
                  placeholder="비밀번호 확인"
                  style={{
                    float: 'left',
                    boxSizing: 'border-box',
                    width: '50%',
                    paddingLeft: 20,
                  }}
                  onChange={this._onChange}
                />

                <div className="clear"></div>
              </li>
              <li>
                <NumberFormat
                  name="mobile"
                  format="###-####-####"
                  value={mobile}
                  className="common_input login_input"
                  placeholder="휴대폰(-없이 숫자만 입력)"
                  onChange={this._onChange}
                />
              </li>
              <li style={{ width: '100%' }}>
                <input
                  name="email"
                  type="text"
                  className="common_input login_input"
                  value={email}
                  onChange={this._onChange}
                  placeholder="이메일"
                />
                {/*<Email className="common_input login_input" domains={customDomains} value={email} onChange={this._onChange} placeholder="이메일"/>*/}
              </li>
            </ul>

            <div style={{ height: 4 }}></div>
            <ul className="radius1">
              <li>
                <div className="chek_group1">
                  <input
                    name="aAgree"
                    id="checkbox_1"
                    type="checkbox"
                    value=""
                    checked={aAgree}
                    className="checkbox_img"
                    onChange={this._chkValue}
                  />
                  <label htmlFor="checkbox_1">전체 약관 동의</label>
                </div>
              </li>
              <li className="height_auto">
                <div className="chek_group2">
                  <input
                    name="age14"
                    id="checkbox_4"
                    type="checkbox"
                    value=""
                    checked={aAgree ? true : age14}
                    className="checkbox_img"
                    onChange={this._chkValue}
                  />
                  <label htmlFor="checkbox_4">만 14세 이상입니다</label>
                </div>
                <div className="chek_group2">
                  <input
                    name="mAgree"
                    id="checkbox_2"
                    type="checkbox"
                    value=""
                    checked={aAgree ? true : mAgree}
                    className="checkbox_img"
                    onChange={this._chkValue}
                  />
                  <label htmlFor="checkbox_2">회원가입 약관 동의</label>
                  <a style={{ cursor: 'pointer' }} onClick={this._goRole}>
                    약관보기
                  </a>
                </div>
                <div className="chek_group2">
                  <input
                    name="sAgree"
                    id="checkbox_3"
                    type="checkbox"
                    value=""
                    checked={aAgree ? true : sAgree}
                    className="checkbox_img"
                    onChange={this._chkValue}
                  />
                  <label htmlFor="checkbox_3">
                    서비스 제공을 위한 개인정보 수집/이용
                  </label>
                  <a style={{ cursor: 'pointer' }} onClick={this._goRole}>
                    약관보기
                  </a>
                </div>
              </li>
            </ul>
            <div style={{ height: 15 }}></div>
            <div className="login_btn">
              <a style={{ cursor: 'pointer' }} onClick={this._goStep2}>
                계속하기
              </a>
            </div>
            <div className="etc_login">
              <h2>SNS 로그인으로 가입하기</h2>
              <div>
                <a style={{ cursor: 'pointer' }} onClick={this._onTwitter}>
                  <img src="img/login_img/etc_login_01.png" />
                </a>
                {/* <a style={{ cursor: "pointer" }} onClick={this._onFacebook}>
                  <img src="img/login_img/etc_login_02.png" />
                </a> */}
                <a style={{ cursor: 'pointer' }} onClick={this._onGoogle}>
                  <img src="img/login_img/etc_login_03.png" />
                </a>
                <a style={{ cursor: 'pointer' }} onClick={this._onKakao}>
                  <img src="img/login_img/etc_login_04.png" />
                </a>
                <a style={{ cursor: 'pointer' }} onClick={this._onNaver}>
                  <img src="img/login_img/etc_login_05.png" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(JoinStepOne));
